import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackSuccess = null, callbackFinally) => {
    return AppModel.get(
      'get_convibase_for_materials_and_equipment_adjustment_list',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        let modelStore = store.getters.model
        if (!modelStore) {
          modelStore = {}
        }
        modelStore['MaterialsAndEquipmentAdjustmentListModel'] = res.data
        store.commit('setModel', modelStore)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('MaterialsAndEquipmentAdjustmentListModel', key)
  }
}



// WEBPACK FOOTER //
// ./src/models/SearchMaterialsAndEquipmentModel.js